import { Component, ErrorInfo, ReactNode } from 'react';
import { logScreenerPageLoadError } from '../utils/statsig';
import { getDeviceType } from '../utils/getDeviceType';
import { getBrowser } from '../utils/getBrowser';
import { getWithExpiry } from '../utils/sessionStorage';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);

    const applicantGuid = getWithExpiry('applicantGuid') || undefined;
    const jobId = getWithExpiry('jobId') || undefined;

    logScreenerPageLoadError({
      jobId,
      applicantGuid,
      errorCode: error.name,
      errorMessage: error.message,
      deviceType: getDeviceType(),
      browser: getBrowser(),
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page to try again. If the problem persists, contact support.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
